import React from 'react';

export default function FooterComponent() {
    return (
        <footer className="bg-light py-5">
            <div className="container"><div className="small text-center text-muted">Copyright © 2020 - Hondix joias e semi joias</div></div>
        </footer>
    )
}
